import {
  Accessibility,
  BookOpen,
  BadgePoundSterling,
  CalendarCheck,
  CalendarDays,
  CalendarOff,
  CalendarPlus,
  ChartNoAxesCombined,
  ClipboardList,
  Clock3,
  FolderOpen,
  History,
  House,
  Inbox,
  ListChecks,
  ListTodo,
  Music,
  MessageSquareText,
  NotebookPen,
  ReceiptText,
  Repeat2,
  School,
  Settings,
  Sun,
  TrendingUp,
  Trophy,
  Users,
  UsersRound,
  Wrench,
  type LucideIcon,
} from "lucide-react";

// Attach decoration to the destination, leaving the permission-filtered
// navigation data and each link's accessible name unchanged.
const destinationIcons: Record<string, LucideIcon> = {
  "/help": BookOpen,
  "/today": Sun,
  "/diary": CalendarDays,
  "/students": Users,
  "/group-activities": ClipboardList,
  "/repertoire": Music,
  "/grooves": Wrench,
  "/neck-diagrams": Music,
  "/files": FolderOpen,
  "/inbox": Inbox,
  "/enquiries": MessageSquareText,
  "/waiting": ListTodo,
  "/queue": ListTodo,
  "/reports": ChartNoAxesCombined,
  "/schools": School,
  "/payments/invoices": ReceiptText,
  "/payments/log": BadgePoundSterling,
  "/reports/unpaid-lessons": ReceiptText,
  "/payments/history": History,
  "/availability": CalendarCheck,
  "/time-off": CalendarOff,
  "/recurring-lessons": Repeat2,
  "/invoicing": BadgePoundSterling,
  "/staff": UsersRound,
  "/teaching-assignments": ClipboardList,
  "/settings": Settings,
  "/home": House,
  "/book": CalendarPlus,
  "/lessons": CalendarDays,
  "/history": History,
  "/invoices": ReceiptText,
  "/practice": ListChecks,
  "/my-practice": Clock3,
  "/practice-history": History,
  "/practice-leaderboard": Trophy,
  "/awards": Trophy,
  "/progress": TrendingUp,
  "/notes": NotebookPen,
  "/accessibility": Accessibility,
};

export function SidebarIcon({ to }: { to: string }) {
  const Icon = destinationIcons[to];
  if (!Icon) return null;
  return (
    <Icon
      className="sidebar-nav-icon"
      size={18}
      strokeWidth={1.6}
      aria-hidden="true"
      focusable="false"
    />
  );
}

